import * as React from 'react'
import {
  DataGrid,
  GridColDef,
  GridToolbar,
  GridPaginationModel
} from '@mui/x-data-grid'
import { useState } from 'react'
import { Pagination, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { GridCallbackDetails, GridFilterModel } from '@mui/x-data-grid/models'

interface Props {
  columns: GridColDef<object>[]
  rows: object[] | []
  rowCount?: number
  paginationModel?: {
    page: number
    pageSize: number
  }
  paginationMode?: 'client' | 'server'
  filterMode?: 'client' | 'server'
  editMode?: 'cell' | 'row'
  onPaginationModelChange?: any
  onCellClick?: any
  onCellEditStop?: any
  onCellEditStart?: any
  processRowUpdate?: any
  onProcessRowUpdateError?: any
  onRowSelectionModelChange?: any
  autoPageSize?: boolean
  initialState?: any
  rowSelectionModel?: Array<number | string> | number | string
  rowHeight?: number
  disableRowSelectionOnClick?: boolean
  checkboxSelection?: boolean
  sx?: object
  loading?: boolean
  slots?: any
  pageSizeOptions?: (
    | number
    | {
        value: number
        label: string
      }
  )[]
  disableColumnMenu?: boolean
  disableVirtualization?: boolean
  sortingMode?: 'client' | 'server'
  onSortModelChange?: any
  onFilterModelChange?:
    | ((model: GridFilterModel, details: GridCallbackDetails<'filter'>) => void)
    | undefined
}

const Tables = React.forwardRef((props: Props, ref) => {
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const pageSize = React.useMemo(() => {
    return props.initialState?.pagination?.paginationModel?.pageSize ?? 15
  }, [props.initialState])

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value)

    props.onPaginationModelChange &&
      props.onPaginationModelChange(
        {
          page: value - 1,
          pageSize: pageSize
        },
        1
      )
  }

  React.useImperativeHandle(ref, () => {
    return {}
  })

  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        checkboxSelection
        sx={{
          height: 'auto',
          '& .MuiDataGrid-footerContainer': {
            justifyContent: 'center',
            display: 'none'
          },
          minHeight: 300,
          '& .MuiDataGrid-columnHeaders': {
            bgcolor: '#EDEFF0'
          },
          '& .MuiDataGrid-virtualScroller': {
            minHeight: '50px!important'
          }
        }}
        slots={{ toolbar: GridToolbar }}
        disableColumnSelector
        disableColumnFilter
        disableDensitySelector
        {...props}
        columns={props.columns.map((item) => {
          if (item.disableColumnMenu === false) {
            return item
          } else item.disableColumnMenu = true

          return item
        })}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 }
          }
        }}
        filterMode={props.filterMode ? props.filterMode : 'server'}
        onFilterModelChange={props.onFilterModelChange}
      />

      <Stack
        direction={'row'}
        alignItems="center"
        pt={2}
        justifyContent="center"
      >
        <Pagination
          count={Math.ceil(Number(props.rowCount) / pageSize)} // 假设总共有100项数据，这里应该是从后端获取的
          page={page}
          onChange={handleChange}
          variant="outlined"
          shape="rounded"
          color="primary"
        />

        <Typography>{`${t('Total')} ${props.rowCount}`}</Typography>
      </Stack>
    </div>
  )
})
export default Tables
